<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path opacity="0.5" d="M8 0.116852C10.1058 0.116851 12.0852 0.936694
      13.5742 2.42577C15.0633 3.91484 15.8831
      5.89415 15.8831 8C15.8831 10.1059 15.0633 12.0852 13.5742 13.5742C12.0852
      15.0633 10.1059 15.8831 8 15.8831C5.89415
      15.8831 3.91484 15.0633 2.42577 13.5742C0.936694 12.0852 0.11685 10.1059
      0.11685 8C0.11685 5.89415 0.936693 3.91484
      2.42576 2.42577C3.91484 0.936695 5.89415 0.116852 8 0.116852ZM8
      14.8669C11.7865 14.8669 14.8669 11.7865 14.8669 8C14.8669
      4.21354 11.7865 1.13315 8 1.13315C4.21354 1.13315 1.13315 4.21354 1.13315
      8C1.13315 11.7865 4.21354 14.8669 8 14.8669Z"
            fill="#0D7BC4"
            stroke="#0D7BC4"
            stroke-width="0.233703"/>
      <path d="M9.81231 8.23363L7.78305 10.2628C7.65397 10.392 7.44468
      10.392 7.31565 10.2628C7.18662 10.1338
      7.18662 9.92452 7.31565 9.79549L9.11124 7.99997L7.31571
      6.2045C7.18667 6.07541 7.18667 5.86616 7.31571
      5.73712C7.44474 5.60804 7.65402 5.60804 7.7831 5.73712L9.81237
      7.76635C9.87688 7.8309 9.9091 7.91541
      9.9091 7.99996C9.9091 8.08455 9.87682 8.16912 9.81231 8.23363Z"
            fill="#0D7BC4"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(180)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconArrow'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconArrow.vue